module.exports = __webpack_public_path__ + "media/images/emblems/Urdorf-blazon-37a824f09a749ad246a35ad1c97297bf.svg";